import styled from 'styled-components';
import { Button } from '@bynder/design-system';

export const ScriptButton = styled(Button)`
    max-width: 44px;
`;
